
export let standardDateFormat = "MM/DD/YYYY";

export const defaultLandingView = "card";
export const listLandingView = "list";
export let SPSToken = "";

/**
 * Set date format by given preference
 * @param {*} prefFormat -> preference
 */
export const setDateFormatByPreference = (prefFormat) => {
  standardDateFormat = prefFormat;
};

/**
 * Set Share point token
 * @param {*} token 
 */
export const setSPSToken = (token) => {
  SPSToken = token;
};

export const dateMonthFormat = "MMM YYYY";
export const IDLE_TIME = 3 * 60 * 1000;
export const MINIMUM_SIDE_LEVEL_TO_ENABLE_BIOMETRIC = 4;

export let isUserHasEditPermission = false;

/**
 * Set User edit permission
 * @param {*} perObj 
 */
export const setUserEditPermission = (perObj) => {
  const readOnly = ["r", "i"];
  isUserHasEditPermission =
    readOnly.indexOf(perObj.idKey) !== -1 ? false : true;
};

export const PROPERTY_EDIT = {
  edit: 1,
};

export const PROPERTY_SOLD_STATUS = 3;

export const PERFORMANCE_API_CONTEXT = "/Performance";
export const PROPERTY_API_CONTEXT = "/Property";

/**
 * Data format default
 */
export const DATA_FORMAT = {
  NumberFormat: "number",
  DecimalNumber: "decimalnumber",
  Header: "headers",
  Text: "text",
  Currency: "currency",
  DecimalCurrency: "decimalcurrency",
  TotalCurrency: "totalcurrency",
  TotalCurrencyDecimal: "totalcurrencydecimal",
  Year: "year",
  Month: "month",
  Percent: "percent",
  Factor: "factor",
  PerDecimal: "percentdecimal",
  DateFormat: "date",
  Dropdown: "dropdown",
  MultiSelect: "multiselect",
  MonthYear: "monthyear",
  DispositionMonth: "dispositionmonth",
  YardiCode: "yardicode",
  AvgRentCurrencyDecimal: "avgrentcurrencydecimal",
  LocalDateConst: "en-US",
};

/**
 * Property Tabs
 */
export const imProperty_tabs = [
  {
    label: "General Asset Summary",
    id: 1,
  },
  {
    label: "Map",
    id: 2,
  },
  {
    label: "Operating Summary",
    id: 3,
  },
  {
    label: "Basis & Debt Summary",
    id: 4,
  },
];

export const regXForYear = /^(18|19|20)\d{2}$/;
export const regXForMonth = /^.{0,4}/;
export const regXForYardiCode = /^[a-zA-Z]{5}[0-9]{3}/;

/** Widget Names */
export const STAFFING_WIDGET_NAMES = {
  GUARD_FORCE_STAFF: "Guard Force Staff",
  GUARD_FORCE_PATROLS: "Guard Force Patrols",
  SITE_VISITOR: "Site Visitor",
};

/** Sections */
export const SECTIONS = {
  REPORTING: 113,
  REQUEST: 97,
  REQUEST_LISTING: 98,
  CREATE_REQUEST: 102,
  RESPOND_TO_REQUEST: 103,
  TENANT: 94,
  TENANT_LIST: 95,
  CONTACT_LIST: 99,
  ADD_UPDATE_TENANT: 100,
  ADD_UPDATE_CONTACT: 101,
  ABOUT_US: 79,
  CONFIGURATION: 75,
  HEALTH_AND_SAFETY: 19,
  STAFFING: 26,
  SECURITY_AND_OPERATION: 20,
  MAINTENANCE: 27,
  FINANCIAL: 24,
  FINANCIAL_PROPERTY: 68,
  FINANCIAL_GRAPH_COMPARE: 69,
  DASHBOARD: 28,
  SITE_PROFILE: 25,
  FACILITY_PERFORMANCE: 23,
  GUARD_FORCE_PATROL: 3,
  STAFFING_SUMMARY: 5,
  SITE_PERSONNEL_ACTIVITY: 6,
  TOTAL_RECORDABLE_INCIDENT_YTD: 7,
  TOTAL_RECORDABLE_INCIDENT_MONTHLY: 8,
  HSE_INCIDENT_SUMMARY: 9,
  MAINTENANCE_COMPLETED: 10,
  MAINTENANCE_NOT_COMPLETED: 11,
  INCIDENT_OPEN_ISSUES: 12,
  RESET_TO_DEFAULT: 29,
  ADD_WIDGET: 31,
  HEALTH_AND_SAFETY_NEAR_MISS: 47,
  SECURITY_INCIDENTS: 48,
  SITE_PERSONNEL_ACTIVITY_GRAPH: 49,
  GUARD_FORCE_PATROLS_GRAPH: 50,
  SECURITY_INCIDENT_REPORT: 58,
  CURRENT_STAFFING_TABLE: 59,
  OPERATIONAL_INCIDENTS: 64,
  LIST_OF_OPEN_HIGH_SEVERITY_ISSUES: 65,
  LIST_OF_OPEN_MEDIUM_SEVERITY_ISSUES: 66,
  LIST_OF_OPEN_LOW_SEVERITY_ISSUES: 67,
  PROPERTY_DRILLDOWN: 68,
  GRAPHICAL_COMPARISON: 69,
  DATA_HALL_CAPACITY: 71,
  TENANT_LISTING: 72,
  SITE_PLAN: 74,
  ADD_UPDATE_WIDGET: 76,
  CONFIGURE_GROUP_WIDGET: 77,
  CONFIGURE_FACILITY_PERFORMANCE: 78,
  ACCESS_DENIALS: 86,
  CONFIGURE_DATA_CENTER: 80,
  CONFIGURE_PATROLS: 81,
  LOAD_HISTORICAL_DATA: 85,
  VIEW_APM_BUTTON: 82,
  DASHBOARD_WIDGET_CONFIG: 87,
  BUDGETED_HEAD_COUNT_EDIT: 93,
  MAINTENANCE_IN_PROGRESS: 96,
  COMMUNICATION: 104,
  COMMUNICATION_LIST: 105,
  SEND_COMMUNICATION: 106,
  CONFIGURE_EMPLOYEE_AND_DATA_CENTER: 107,
  CONFIGURE_REQUEST_TYPE_DEPARTMENT_AND_DATA_CENTER: 108,
  HEALTH_AND_SAFETY_COMPONENT: 109,
  HSE_INCIDENT_MENU: 110,
  HSE_INCIDENT_LIST: 111,
  HSE_INCIDENT_CREATE: 112,
  SECURITY_INCIDENT_CREATE: 117,
  SECURITY_INCIDENT: 114,
  SDC_GRANT_ACCESS:133,
  PRINT_BRR_ABRF_FORM:134,
  EVENT_NOTIFICATION: 135,
  REPLY_COMMUNICATION: 136,
  UPDATE_HSE: 138,
  SECURITY_EVENT_NOTIFICATION: 139,
  UPDATE_SECURITY: 140,
  CONFIGURE_ROUTING_AND_NOTIFICATION: 143,
  ADD_EDIT: "Add OR Edit",
  VIEW: "View",
  FULL_ACCESS:"Full Access",
  MENU_SETTINGS:151,
  API_KEY_MANAGEMENT: 157,
  WELCOME: 158
};

/**
 * Report navigation list
 */
export const reportsNavList = [
  { name: "Health & Safety", id: SECTIONS.HEALTH_AND_SAFETY },
  { name: "Security", id: SECTIONS.SECURITY_AND_OPERATION },
  { name: "Staffing", id: SECTIONS.STAFFING },
  { name: "Maintenance", id: SECTIONS.MAINTENANCE },
  { name: "Facility Performance", id: SECTIONS.FACILITY_PERFORMANCE },
  { name: "Financial", id: SECTIONS.FINANCIAL },
  { name: "Site Profile", id: SECTIONS.SITE_PROFILE },
];

/** Facility Reports */
export const facilityReports = {
  Generator_Power: "Generator Power",
  Generator_Fuel: "Generator Fuel",
  UPS_Power: "UPS Power",
  UPS_Batteries: "UPS Batteries",
  Power_Usage_Effectiveness: "Power Usage Effectiveness",
  Chiller_Performance: "Chiller Performance",
};

/** Request Types */
export const REQUEST_TYPE = {
  ACCESS_REQUEST: 8,
  ACCESS_REMOVAL: 9,
  ACCESS_OTHER: 10,
  ACCESS_DELIVERY_AND_SHIPPING: 2
};

/** BIOMETRIC REQUIRED VALUES**/
export const BIOMETRIC_VALUES = {
  BIOMETRIC_REQUIRED: "yes",
  BIOMETRIC_NOT_REQUIRED: "no"
}

/** Request status */
export const REQUEST_STATUS = {
  DRAFT: 1,
  CREATED: 2,
  INPROGRESS: 3,
  APPROVED: 4,
  DENIED: 5,
  WAITING_FOR_SIGNED_BRR: 6,
  ABRF_APPROVED: 7,
  AWAITING_FOR_ABRF: 8,
  COMPLETED: 9,
  EXPIRED: 12,
  ENGINEERING_APPROVED: 13,
  SECURITY_APPROVED: 14,
};

/** Incident Status */
export const INCIDENT_STATUS = {
  DRAFT: 1,
  CREATED: 2,
};

/** Badge types */
export const BADGE_TYPE = {
  Customer_Tenant_Badge: 1,
  Temporary_Access_Badge: 2,
  Visitor_Badge: 3,
  Contractor_Badge: 4,
  Employee_Badge: 7,
  Emergency_Services_Badge: 8,
  Forgot_Badge_Type: 9,
};

/** Operators */
export const Operators = {
  //Greater than operation check
  GreaterThan: (a, b) => {
    a = isNaN(parseFloat(a)) ? a : parseFloat(a);
    b = isNaN(parseFloat(b)) ? b : parseFloat(b);
    const result = a > b;
    let message = () => {};
    if (result === false) {
      message = message = (a, b) => {
        return a + " should be Greater than " + b;
      };
    }
    return { result, message };
  },
  //Less than operation check
  LessThan: (a, b) => {
    a = isNaN(parseFloat(a)) ? a : parseFloat(a);
    b = isNaN(parseFloat(b)) ? b : parseFloat(b);
    const result = a < b;
    let message = () => {};
    if (result === false) {
      message = message = message = (a, b) => {
        return a + " should be Less than " + b;
      };
    }
    return { result, message };
  },
 
  //Less than or null check
  LessThanOrNull: (a, b) => {
    a = isNaN(parseFloat(a)) ? a : parseFloat(a);
    b = isNaN(parseFloat(b)) ? b : parseFloat(b);
    const result =
      b !== "" && b !== null && b !== undefined && b !== 0 ? a < b : true;
    let message = () => {};
    if (result === false) {
      message = message = message = (a, b) => {
        return a + " should be Less than " + b;
      };
    }
    return { result, message };
  },
  //Equal to check
  EqualsTo: (a, b) => {
    a = isNaN(parseFloat(a)) ? a : parseFloat(a);
    b = isNaN(parseFloat(b)) ? b : parseFloat(b);
    let result = true;
    if (isNaN(a) && isNaN(a) && a.length === b.length) {
      a = (a || "").split("|");
      b = (b || "").split("|");
      if (a.length === b.length) {
        a.forEach((x) => {
          if (b.find((y) => y === x) === undefined) {
            result = false;
          }
        });
      } else {
        result = false;
      }
    } else {
      result = a === b;
    }

    let message = () => {};
    if (result === false) {
      message = message = message = (a, b) => {
        return a + " should be Equal to " + b;
      };
    }
    return { result, message };
  },
  //Less than equals to check
  LessThanEqualsTo: (a, b) => {
    a = isNaN(parseFloat(a)) ? a : parseFloat(a);
    b = isNaN(parseFloat(b)) ? b : parseFloat(b);
    let result = a <= b;
    if (a === -1) {
      result = false;
    }
    let message = () => {};
    if (result === false) {
      message = (a, b) => {
        return `${a} should be Less than or equal to ${b}`;
      };
    }
    return { result, message };
  },
  // Like check // contains or not
  Like: (a, b) => {
    const result = a.indexOf(b) !== -1;
    let message = () => {};
    if (result === false) {
      message = message = message = (a, b) => {
        return a + " not contain " + b;
      };
    }
    return { result, message };
  },
  //Contains check
  Contains: (a, b) => {
    let result = false;
    let message = () => {};
    if (typeof b === typeof a) {
      result = b.includes(a);
    }
    if (result === false) {
      message = message = message = (a, b) => {
        return a + " not contain " + b;
      };
    }
    return { result, message };
  },
  //greater than equals to check
  GreaterThanEqualsTo: (a, b) => {
    a = isNaN(parseFloat(a)) ? a : parseFloat(a);
    b = isNaN(parseFloat(b)) ? b : parseFloat(b);
    const result = a >= b;
    let message = () => {};
    if (result === false) {
      message = (a, b) => {
        return `${a} should be Greater than or equal to ${b}`;
      };
    }
    return { result, message };
  },
  //Not equals check
  NotEquals: (a, b) => {
    a = isNaN(parseFloat(a)) ? a : parseFloat(a);
    b = isNaN(parseFloat(b)) ? b : parseFloat(b);
    const result = a !== b;
    let message = () => {};
    if (result === false) {
      message = (a, b) => {
        return `${a} should be Not equals to ##fieldNameB## ${b}`;
      };
    }
    return { result, message };
  },
  //Not in check
  NotIn: (a, b = []) => {
    const result =
      (
        (Array.isArray(b)
          ? b
          : typeof b === "string"
          ? (b || "").split("|")
          : []) || []
      ).find((x) => x === a || (a?.split("|") || []).find((t) => t === x)) ===
      undefined;
    let message = () => {};
    if (result === false) {
      message = "##fieldNameB## should not contain value " + a;
    }
    return { result, message };
  },
  //In Check
  In: (a, b = []) => {
    const result =
      (
        (Array.isArray(b)
          ? b
          : typeof b === "string"
          ? (b || "").split("|")
          : []) || []
      ).find((x) => x === a || (a?.split("|") || []).find((t) => t === x)) !==
      undefined;
    let message = () => {};
    if (result === false) {
      message = (a) => {
        return a + " should exist in ##fieldNameB## ";
      };
    }
    return { result, message };
  },
  //Between value check
  Between: (a, b = []) => {
    const result = a > b[0] && a < b[1];
    let message = () => {};
    if (result === false) {
      message = (a) => {
        return a + " should be between ##fieldNameB## ";
      };
    }
    return { result, message };
  },
  BetweenInclusive: (a, b = []) => {
    const result = a >= b[0] && a <= b[1];
    let message = () => {};
    if (result === false) {
      message = (a) => {
        return a + " should be between  ##fieldNameB## ";
      };
    }
    return { result, message };
  },
};
export const maxFileSize = 26214400; //in bytes
export const maxZipFileSize = 30408704; //in bytes
export const allowedFileExtensions = ".docx,.xlsx,.xls,.pdf,.csv,.txt,.doc";

/** Pending notifications */
export const pendingNotification = [
  {
    headerClass: "w-10",
    colName: "Notification Type",
    keyName: "notificationType",
  },
  {
    headerClass: "w-10",
    colName: "Title",
    keyName: "title",
  },
  {
    headerClass: "w-10",
    colName: "Message",
    keyName: "message",
  },
  {
    headerClass: "w-10",
    colName: "Created By",
    keyName: "createdBy",
  }
]

export const DCOP_SOURCE_SYSTEM = 8;
export const SHAREPOINT_SOURCE_SYSTEM = 9;

/** Tooltip labels */
export const TOOLTIP_LABEL = {
  DOWNLOAD: "Download",
  CLEAR_FILTER: "Clear Filter",
  REFRESH: "Refresh",
  SAVE: "Save",
  EDIT: "Edit",
  CANCEL:"Cancel",
  DELETE: "Delete",
  VIEW: "View",
  DISTRIBUTION_GROUP: "Distribution Group",
  MODULE: "Module",
  DATA_CENTER:"Data Center",
  CATEGORY: "Category",
  PRINT: "Print",
  PRINT_REQUEST: "Print Request",
  PRINT_BRR: "Print BRR",
  REPORTED_BY: "Reported By",
  INCIDENT_DATE_AND_TIME: "Incident Date and Time",
  SUB_CATEGORY: "Sub Category",
  INCIDENT_STATUS: "Incident Status",
  EMAIL_LOG:"Email Log",
  DESCRIPTION: "Description",
  NOTES: "Notes",
  OBSERVED_BY: "Observed By",
  OBSERVATION_DATE_AND_TIME: "Observation Date and Time",
  CONTRIBUTING_FACTOR: "Contributing Factor",
  PROJECTS: "Projects",
  REQUESTED_FOR: "Requested For",
  REQUESTED_FOR_EMAIL: "Requested For Email",
  BADGE_TYPE: "Badge Type",
  REQUESTED_FOR_COMPANY: "Requested For Company",
  BADGE_ACTIVE_FROM: "Badge Active From",
  BADGE_ACTIVE_TO:  "Badge Active To",
  BADGE_ACTIVE_TO_DATE: "Badge Active To Date",
  BADGE_NUMBER: "Badge Number",
  VISITOR_CHECK_IN: "Visitor Check In",
  VISITOR_CHECK_OUT: "Visitor Check Out",
  RELATIONSHIP: "Relationship",
  REQUESTOR_NAME: "Requester Name",
  SUITE: "Suite",
  REQUESTED_COMPLETION_DATE: "Requested Completion Date",
  REQUEST_DESCRIPTION: "Request Description",
  REQUEST_TYPE: "Request Types",
  RESPONSE_HISTORY: "Response History",
  REASON_FOR_DELETE: "Reason For Delete",
  YES: "Yes",
  NO: "No",
  TENANT_SETTINGS:"Tenant Settings",
  REQUEST_SETTINGS:"Request Settings",
  COMMUNICATION_SETTINGS:"Communication Settings",
  HSE_SETTINGS:"Health And Safety Settings",
  SECURITY_SETTINGS:"Security Incident Settings",
  ACTIVE:"Active",
  INACTIVE:"InActive",
  BACK: "Back",
  DEACTIVATE: "Deactivate",
  API_NOTE: "API Note",
  API_INTERFACE: "API Interface",
  API_Doc: "API Doc",
  DEACTIVATE_MESSAGE: "Deactivate Message",
  COPY: "Copy",
  NOTE_FOR_SPECIAL_PHYSICAL_KEY: "Notes for Special Physical Key",
  PHYSICAL_KEY: "Physical Key",
  BIOMETRICS: "Biometrics",
  VEHICLE_LICENSE_PLATE: "Vehicle License Plate",
  GRANT_ACCESS_NOT_FOUND: "Grant Access record Not found",
  GRANT_ACCESS_FOUND: "Grant Access record found"
}

/** Routing validations */
export const routingValidation = [
  {
    valueKey: "distributionGroup",
    type: "text",
    isRequired: true,
    fieldsName: "Distribution Group"
  },
  {
    valueKey: "propertyId",
    type: "text",
    isRequired: true,
    fieldsName: "Data Center"
  },
  {
    valueKey: "categoryId",
    type: "text",
    isRequired: true,
    fieldsName: "Category"
  },
  {
    valueKey: "moduleId",
    type: "text",
    isRequired: true,
    fieldsName: "Module"
  }
];

/**
 * Return routing and notification columns
 * @param {*} colFilteredObj -> column filter object
 * @param {*} masterData -> master data
 * @returns 
 */
export function getRoutingAndNotificationColumn (colFilteredObj, masterData) {
  return  [
      {
        colName: "Data Center",
        keyName: "DataCenter",
        filterType: "multiSelect",
        selectedIds: colFilteredObj.DataCenter,
        optionsList: masterData.dataCenterMasterData,
        dataFormat: "Text",
        header: "Data Centers"
      },
      {
        colName: "Module Name",
        keyName: "Module",
        filterType: "multiSelect",
        selectedIds: colFilteredObj.Module,
        optionsList: masterData.moduleMasterData,
        dataFormat: "Text"
      },
      {
        colName: "Category",
        keyName: "Category",
        filterType: "multiSelect",
        selectedIds: colFilteredObj.Category,
        optionsList: masterData.categoryMasterData,
        dataFormat: "Text"
      },
      {
        colName: "Distribution Group",
        keyName: "DistributionGroup",
        filterType: "multiSelect",
        selectedIds: colFilteredObj.DistributionGroup,
        optionsList: masterData.distributionGroupMasterData,
        dataFormat: "Text"
      },
      {
        colName: "Recipient",
        keyName: "Recipient",
        dataFormat: "MultiCount",
        header: "Recipients",
        align: "center"
      },
      {
        colName: "Action",
        isHideFilter: true,
        noValue: true,
        iconType: [{action: "delete", isIconVisibleKey:  ""}]
      }
    ]
}

export const ADD_DISTRIBUTION_GROUP = "Add Distribution Group";
export const DISTRIBUTION_GROUP_LIST = "Distribution Group List"


export const ADD_RECIPIENT = "Add Recipient";
export const RECIPIENT_LIST = "Recipient List"

export const EMAIL_LOG_HEADER = "Email Log History";

export const EMAIL_LOG_CONFIG = [
  {
    name: "Data Center",
    key: "propertyName",
    format: "Text"
  },
  {
    name: "Email",
    key: "emailId",
    format: "Text"
  },
  {
    name: "Sent On",
    key: "emailSentOn",
    format: "DateTime"
  }
];

/**
 * Return security Setting columns
 * @param {*} colFilteredObj -> column filter object
 * @param {*} masterData -> master data
 * @returns 
 */
export function getSecuritySettingColumn (colFilteredObj, masterData) {
  return  [
      {
        name: "Incident Status",
        colName: "Incident Status",
        keyName: "IncidentStatus",
        filterType: "multiSelect",
        key: "IncidentStatus",
        type: "Child",
        isVisible: true,
        isRequired: true,
        selectedIds: colFilteredObj.IncidentStatus,
        optionsList: masterData.statusMasterData,
        header: "Incident Status",
        dataFormat: "Text",
        editConfig: {
          type: "TextField",
          isEditField: true,
          isAddField: true
    
        }
      },
      {
        name: "List Order By",
        colName: "List Order By",
        keyName: "ListOrderBy",
        key: "ListOrderBy",
        type: "Child",
        isVisible: true,
        isRequired: true,
        header: "List Order By",
        dataFormat: "Number",
        editConfig: {
          type: "TextNumber",
          isEditField: true,
          isAddField: true    
        }
      },
      {
        name: "Is Active",
        colName: "Is Active",
        keyName: "IsActive",
        filterType: "multiSelect",
        key: "IsActive",
        type: "Child",        
        selectedIds: colFilteredObj.IsActive,
        optionsList:  [
          { id: "No", value: "No" },
          { id: "Yes", value: "Yes" }
        ],
        dataFormat: "Text",
        header: "Is Active",
        editConfig: {
          type: "TextField",
          isEditField: false,
          isAddField: false
        }
      },
      {
        colName: "Action",
        isHideFilter: true,
        noValue: true,
        iconType: [{action: "activeDeactivate", isIconVisibleKey:  "IsDefault"}, {action: "edit", isIconVisibleKey: "IsDefault"}],
        renderComponent: "renderActionColumn"
      }
    ]
}

export const SECURITY_SETTINGS_HEADER = "Security Status Maintenance List";

export const SECURITY_CATEGORY_HEADER = "Security Category Maintenance List";

/**
 * Return security Setting category
 * @param {*} colFilteredObj -> column filter object
 * @param {*} masterData -> master data
 * @returns 
 */
export function getSecurityCategoryColumn (colFilteredObj, masterData) {
  return  [
      {
        colName: "Category",
        keyName: "Category",
        filterType: "multiSelect",
        selectedIds: colFilteredObj.IncidentCategory,
        optionsList: masterData.categoryMasterData,
        header: "Category",
        dataFormat: "Text",
        name: "Category",
        key: "Category",
        type: "Child",
        isVisible: true,
        isRequired: true,
        isNonEditable: true,
        editConfig: {
          type: "TextField",
          isEditField: true,
          isAddField: true
    
        }
      },
      {
        name: "List Order By",
        colName: "List Order By",
        keyName: "ListOrderBy",
        key: "ListOrderBy",
        type: "Child",
        isVisible: true,
        isRequired: true,
        header: "List Order By",
        dataFormat: "Number",
        editConfig: {
          type: "TextNumber",
          isEditField: true,
          isAddField: true    
        }
      },
      {
        name: "Is Active",
        colName: "Is Active",
        keyName: "IsActive",
        filterType: "multiSelect",
        key: "IsActive",
        type: "Child",        
        selectedIds: colFilteredObj.IsActive,
        optionsList:  [
          { id: "No", value: "No" },
          { id: "Yes", value: "Yes" }
        ],
        dataFormat: "Text",
        header: "Is Active",
        editConfig: {
          type: "TextField",
          isEditField: false,
          isAddField: false
        }
      },
      {
        colName: "Action",
        isHideFilter: true,
        noValue: true,
        iconType: [{action: "activeDeactivate", isIconVisibleKey:  "IsDefault"}, {action: "edit", isIconVisibleKey: ""}],
        renderComponent: "renderActionColumn"
      }

    ]
}

export const SECURITY_SUB_CATEGORY_HEADER = "Security Sub Category Maintenance List";

/**
 * Return security SubCategory columns
 * @param {*} colFilteredObj -> column filter object
 * @param {*} masterData -> master data
 * @returns 
 */
export function getSecuritySubCategoryColumn (colFilteredObj, masterData) {
  return  [
      {
        colName: "Sub Category",
        keyName: "SubCategory",
        filterType: "multiSelect",
        selectedIds: colFilteredObj.SubCategory,
        optionsList: masterData.subCategoryMasterData,
        header: "Sub Category",
        dataFormat: "Text",
        name: "Sub Category",
        key: "SubCategory",
        type: "Child",
        isVisible: true,
        isRequired: true,
        isNonEditable: true,
        editConfig: {
          type: "TextField",
          isEditField: true,
          isAddField: true
    
        }
      },
      {
        name: "List Order By",
        colName: "List Order By",
        keyName: "ListOrderBy",
        key: "ListOrderBy",
        type: "Child",
        isVisible: true,
        isRequired: true,
        header: "List Order By",
        dataFormat: "Number",
        editConfig: {
          type: "TextNumber",
          isEditField: true,
          isAddField: true    
        }
      },
      {
        name: "Is Active",
        colName: "Is Active",
        keyName: "IsActive",
        filterType: "multiSelect",
        key: "IsActive",
        type: "Child",        
        selectedIds: colFilteredObj.IsActive,
        optionsList:  [
          { id: "No", value: "No" },
          { id: "Yes", value: "Yes" }
        ],
        dataFormat: "Text",
        header: "Is Active",
        editConfig: {
          type: "TextField",
          isEditField: false,
          isAddField: false
        }
      },
      {
        colName: "Action",
        isHideFilter: true,
        noValue: true,
        iconType: [{action: "activeDeactivate", isIconVisibleKey:  "IsDefault"}, {action: "edit", isIconVisibleKey: ""}],
        renderComponent: "renderActionColumn"
      }

    ]
}